import React from 'react';
import { IndicatorProps } from 'react-select';

import Close from 'components/Icons/Close';

import * as Interfaces from '../interfaces';
import * as Styled from '../styled';

const ClearIndicator: (
  props: Interfaces.SelectComponentProps
) => React.FC<IndicatorProps<Interfaces.OptionType>> = ({
  onClear = () => {},
  value: selected
  // eslint-disable-next-line react/display-name
}) => ({ innerProps }) => {
  let isItemSelected: boolean;
  if (selected instanceof Array) {
    isItemSelected = selected.length > 0;
  } else {
    isItemSelected = !!(selected as any).value;
  }

  return isItemSelected ? (
    <Styled.ClearIndicatorWrapper {...innerProps} onClick={onClear}>
      <Close height={18} width={18} />
    </Styled.ClearIndicatorWrapper>
  ) : (
    <div {...innerProps} />
  );
};

export default ClearIndicator;
